import { CHANNEL_COUNT_FOR_WALLPAPER, MAIN_CHANNEL_INDEX_IN_WALLPAPER } from '../../constants';

import { ChannelWallpaperItem } from './getChannelsWallpapers';

function generateArrayOfUnicalNumbers(max: number, length: number): number[] {
    const indexes = new Set<number>();

    while (indexes.size < length) {
        indexes.add(Math.floor(Math.random() * max));
    }

    return Array.from(indexes);
}

export const getChannelWallpapersForPaywall = (
    channels: ChannelWallpaperItem[],
    currentChannel: ChannelWallpaperItem
): (ChannelWallpaperItem | null)[] => {
    const channelsCount = channels.length;
    const channelIndexes = generateArrayOfUnicalNumbers(
        channelsCount,
        channelsCount > CHANNEL_COUNT_FOR_WALLPAPER ? CHANNEL_COUNT_FOR_WALLPAPER : channelsCount
    );

    return new Array(CHANNEL_COUNT_FOR_WALLPAPER).fill(null).map((_, index) => {
        if (index === MAIN_CHANNEL_INDEX_IN_WALLPAPER) {
            return currentChannel;
        }

        const channelIndex = channelIndexes[index];
        return (channelIndex !== undefined && channels[channelIndex]) || null;
    });
};
